import { useQuery } from '@tanstack/react-query';
import {
  keywordResearchHistoryQueryKeys,
  keywordResearchHistoryService,
  type ListHistoryParams,
} from '@/services/keywordResearchHistoryService';

export function useResearchHistory(params: ListHistoryParams) {
  return useQuery({
    queryKey: keywordResearchHistoryQueryKeys.list(params),
    queryFn: () => keywordResearchHistoryService.list(params),
    enabled: !!params.tenant_id,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}

export function useResearchRun(runId: string | null) {
  return useQuery({
    queryKey: keywordResearchHistoryQueryKeys.detail(runId),
    queryFn: () => {
      if (!runId) throw new Error('runId required');
      return keywordResearchHistoryService.get(runId);
    },
    enabled: !!runId,
    staleTime: 5 * 60_000,
  });
}

export function useActiveResearchRun(tenantId: string) {
  return useQuery({
    queryKey: keywordResearchHistoryQueryKeys.active(tenantId),
    queryFn: () => keywordResearchHistoryService.getActive(tenantId),
    enabled: !!tenantId,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
